import React, { Fragment } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import PageHeader from "../components/PageHeader";
import { withRouter } from "react-router-dom";
import { showToast } from "../utils/library";
import {
  GetUserBankDetails,
  UpdateUserBankDetails,
  GetUserDetails,
  getAuthToken,
  getAuthUuid,
} from "../utils/service";
import { SITENAMEALIAS } from "../utils/init";


const styles = {
  pageWrapper: { padding: "36px 24px 60px" },
  card: {
    background: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid var(--body-color-less2)",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    padding: "28px 32px",
    marginBottom: "28px",
  },
  cardHeaderRow: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    marginBottom: "24px",
  },
  cardHeaderIcon: {
    width: "36px",
    height: "36px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    flexShrink: 0,
  },
  iconBlue: {
    background:
      "linear-gradient(135deg, color-mix(in srgb, var(--btn-color) 15%, transparent), color-mix(in srgb, var(--btn-color) 5%, transparent))",
    color: "var(--btn-color)",
  },
  iconPurple: {
    background:
      "linear-gradient(135deg, color-mix(in srgb, #8b5cf6 15%, transparent), color-mix(in srgb, #8b5cf6 5%, transparent))",
    color: "#8b5cf6",
  },
  iconGreen: {
    background:
      "linear-gradient(135deg, color-mix(in srgb, #10b981 15%, transparent), color-mix(in srgb, #10b981 5%, transparent))",
    color: "#10b981",
  },
  iconOrange: {
    background:
      "linear-gradient(135deg, color-mix(in srgb, #f59e0b 15%, transparent), color-mix(in srgb, #f59e0b 5%, transparent))",
    color: "#f59e0b",
  },
  cardTitle: {
    fontSize: "17px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
    letterSpacing: "-0.2px",
  },
  cardSubtitle: { fontSize: "12px", opacity: 0.5, marginTop: "2px" },
  input: {
    width: "100%",
    padding: "10px 14px",
    fontSize: "14px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    outline: "none",
    transition: "border-color 0.2s",
  },
  inputError: { borderColor: "#ef4444" },
  select: {
    width: "100%",
    padding: "10px 14px",
    fontSize: "14px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    outline: "none",
    appearance: "auto",
  },
  label: {
    display: "block",
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "0.3px",
    opacity: 0.7,
    color: "var(--text-color)",
    marginBottom: "6px",
  },
  formGroup: { marginBottom: "18px" },
  errorText: {
    fontSize: "11px",
    color: "#ef4444",
    marginTop: "4px",
    fontWeight: "500",
  },
  btnPrimary: {
    padding: "11px 32px",
    background: "var(--btn-color)",
    color: "#fff",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "600",
    border: "none",
    cursor: "pointer",
    transition: "opacity 0.2s",
  },
  btnBack: {
    padding: "9px 20px",
    background: "transparent",
    color: "var(--text-color)",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    border: "1px solid var(--body-color-less2)",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    textDecoration: "none",
  },
  statusBadge: {
    display: "inline-flex",
    alignItems: "center",
    padding: "6px 14px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "600",
    lineHeight: "1.4",
  },
  statusPending: {
    background: "color-mix(in srgb, #f59e0b 12%, transparent)",
    color: "#f59e0b",
    border: "1px solid color-mix(in srgb, #f59e0b 20%, transparent)",
  },
  statusVerified: {
    background: "color-mix(in srgb, #10b981 12%, transparent)",
    color: "#10b981",
    border: "1px solid color-mix(in srgb, #10b981 20%, transparent)",
  },
  statusDeclined: {
    background: "color-mix(in srgb, #ef4444 12%, transparent)",
    color: "#ef4444",
    border: "1px solid color-mix(in srgb, #ef4444 20%, transparent)",
  },
  statusDefault: {
    background: "color-mix(in srgb, var(--btn-color) 12%, transparent)",
    color: "var(--btn-color)",
    border: "1px solid color-mix(in srgb, var(--btn-color) 20%, transparent)",
  },
  infoBox: {
    padding: "14px 18px",
    borderRadius: "10px",
    background: "color-mix(in srgb, var(--btn-color) 8%, transparent)",
    border: "1px solid color-mix(in srgb, var(--btn-color) 20%, transparent)",
    fontSize: "13px",
    color: "var(--text-color)",
  },
  successBox: {
    padding: "14px 18px",
    borderRadius: "10px",
    background: "color-mix(in srgb, #10b981 8%, transparent)",
    border: "1px solid color-mix(in srgb, #10b981 20%, transparent)",
    fontSize: "13px",
    color: "#10b981",
    fontWeight: "600",
  },
  gridTwo: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" },
  gridThree: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: "16px",
  },
  /* ── Upload area styles ── */
  uploadArea: {
    border: "2px dashed var(--body-color-less2)",
    borderRadius: "12px",
    padding: "28px 20px",
    textAlign: "center",
    cursor: "pointer",
    transition: "border-color 0.2s, background 0.2s",
    background: "var(--body-color)",
    position: "relative",
  },
  uploadAreaActive: {
    borderColor: "var(--btn-color)",
    background: "color-mix(in srgb, var(--btn-color) 4%, transparent)",
  },
  uploadAreaError: {
    borderColor: "#ef4444",
  },
  uploadIcon: {
    fontSize: "28px",
    opacity: 0.4,
    marginBottom: "10px",
    display: "block",
  },
  uploadText: {
    fontSize: "14px",
    fontWeight: "600",
    color: "var(--text-color)",
    marginBottom: "4px",
  },
  uploadHint: {
    fontSize: "12px",
    opacity: 0.5,
    color: "var(--text-color)",
  },
  uploadedFile: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "10px 14px",
    borderRadius: "10px",
    background: "color-mix(in srgb, #10b981 8%, transparent)",
    border: "1px solid color-mix(in srgb, #10b981 20%, transparent)",
    marginTop: "10px",
  },
  uploadedFileName: {
    fontSize: "13px",
    fontWeight: "600",
    color: "#10b981",
    flex: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  uploadRemoveBtn: {
    background: "none",
    border: "none",
    cursor: "pointer",
    color: "#ef4444",
    fontSize: "14px",
    padding: "0 4px",
    lineHeight: 1,
  },
  docTypeList: {
    listStyle: "none",
    padding: 0,
    margin: "0 0 18px 0",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "8px",
  },
  docTypeItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    fontSize: "13px",
    color: "var(--text-color)",
    opacity: 0.8,
  },
  docTypeDot: {
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    background: "var(--btn-color)",
    flexShrink: 0,
    marginTop: "5px",
  },
  requiresBox: {
    padding: "12px 16px",
    borderRadius: "10px",
    background: "color-mix(in srgb, #f59e0b 8%, transparent)",
    border: "1px solid color-mix(in srgb, #f59e0b 20%, transparent)",
    fontSize: "12px",
    color: "var(--text-color)",
    marginBottom: "20px",
  },
};

/* ─────────────────────────────────────────────
   Accepted document type options
───────────────────────────────────────────── */
const BANK_DOC_TYPES = [
  "Voided Check",
  "Bank Letter / Bank Account Verification Letter",
  "Recent Bank Statement (last 3 months)",
  "Direct Deposit Form / ACH Authorization Form",
  "Screenshot or PDF from Online Banking",
];

const ACCEPTED_FILE_TYPES = ["application/pdf", "image/jpeg", "image/png"];
const MAX_FILE_SIZE_MB = 5;

class BankDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      userUuid: null,
      bankDetailsStatus: "",
      continueUrl: null,

      /* Form field state */
      accountHolderName: "",
      accountNumber: "",
      accountType: "Personal Savings",
      codeType: "ROUTING NUMBER",
      codeValue: "",
      bankName: "",
      bankAddress: "",

      /* Bank verification document fields */
      bankDocType: "Voided Check",
      bankDocFile: null,
      bankDocFileName: "",
      isDragOver: false,
      userCountry: "",

      /* Validation error state */
      isAccountHolderNameInvalid: false,
      isAccountNumberInvalid: false,
      isCodeValueInvalid: false,
      isBankNameInvalid: false,
      isBankAddressInvalid: false,
      isBankDocTypeInvalid: false,
      isBankDocFileInvalid: false,

      /* Error messages */
      accountHolderNameError: "",
      accountNumberError: "",
      codeValueError: "",
      bankNameError: "",
      bankAddressError: "",
      bankDocTypeError: "",
      bankDocFileError: "",

      saveSuccess: false,
      hasWriteAccess: false,
    };

    this.fileInputRef = React.createRef();
  }

  /* ─────────────────────────────────────────────
     IBAN / Account Number Validation Helpers
  ───────────────────────────────────────────── */

  ibanLengths = {
    AL: 28, AD: 24, AT: 20, AZ: 28, BH: 22, BY: 28, BE: 16, BA: 20,
    BR: 29, BG: 22, CR: 22, HR: 21, CY: 28, CZ: 24, DK: 18, DO: 28,
    EG: 29, SV: 28, EE: 20, FO: 18, FI: 18, FR: 27, GE: 22, DE: 22,
    GI: 23, GR: 27, GL: 18, GT: 28, HU: 28, IS: 26, IQ: 23, IE: 22,
    IL: 23, IT: 27, JO: 30, KZ: 20, XK: 20, KW: 30, LV: 21, LB: 28,
    LY: 25, LI: 21, LT: 20, LU: 20, MT: 31, MR: 27, MU: 30, MD: 24,
    MC: 27, ME: 22, NL: 18, MK: 19, NO: 15, PK: 24, PS: 29, PL: 28,
    PT: 25, QA: 29, RO: 24, LC: 32, SM: 27, ST: 25, SA: 24, RS: 22,
    SC: 31, SK: 24, SI: 19, ES: 24, SD: 18, SE: 24, CH: 21, TL: 23,
    TN: 24, TR: 26, UA: 29, AE: 23, GB: 22, VG: 24, AO: 25, BI: 27,
    CM: 27, CV: 25, MZ: 25, SN: 28
  };

  validateIBAN = (iban) => {
    const cleanedIBAN = iban.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
    if (!/^[A-Z]{2}\d{2}[A-Z0-9]{1,30}$/.test(cleanedIBAN)) {
      return { isValid: false, errorMessage: "Invalid IBAN format. Example: GB29NWBK60161331926819" };
    }
    const countryCode = cleanedIBAN.substring(0, 2);
    if (!this.ibanLengths[countryCode]) {
      return { isValid: false, errorMessage: `Invalid or unsupported IBAN country code: ${countryCode}` };
    }
    if (cleanedIBAN.length !== this.ibanLengths[countryCode]) {
      return { isValid: false, errorMessage: `IBAN for ${countryCode} must be exactly ${this.ibanLengths[countryCode]} characters` };
    }
    const rearrangedIBAN = cleanedIBAN.substring(4) + cleanedIBAN.substring(0, 4);
    const numericIBAN = rearrangedIBAN
      .split("")
      .map((char) => (char >= "A" && char <= "Z" ? (char.charCodeAt(0) - 55).toString() : char))
      .join("");
    let remainder = numericIBAN;
    let block;
    while (remainder.length > 2) {
      block = remainder.length > 9 ? 9 : remainder.length;
      const part = remainder.substring(0, block);
      remainder = (parseInt(part, 10) % 97).toString() + remainder.substring(block);
    }
    if (parseInt(remainder, 10) % 97 !== 1) {
      return { isValid: false, errorMessage: "IBAN checksum validation failed. Please check the number." };
    }
    return { isValid: true, errorMessage: "" };
  };

  validateGenericAccountNumber = (accountNumber) => {
    const cleanedNumber = accountNumber.replace(/\s/g, "");
    if (cleanedNumber.length < 8) return { isValid: false, errorMessage: "Account number must be at least 8 characters long" };
    if (cleanedNumber.length > 34) return { isValid: false, errorMessage: "Account number must not exceed 34 characters" };
    if (!/^[a-zA-Z0-9\s\-]+$/.test(accountNumber.trim())) return { isValid: false, errorMessage: "Account number can only contain letters, numbers, spaces, and hyphens" };
    if (/^\d{2}-\d{2}-\d{2}\s\d{8}$/.test(accountNumber.trim())) return { isValid: true, errorMessage: "" };
    if (/^\d{2}-\d{2}-\d{2}\d{8}$/.test(accountNumber.trim())) return { isValid: true, errorMessage: "" };
    if (/^\d{8,17}$/.test(cleanedNumber)) return { isValid: true, errorMessage: "" };
    if (/^\d{9,18}$/.test(cleanedNumber)) return { isValid: true, errorMessage: "" };
    if (/^[a-zA-Z0-9]{8,34}$/.test(cleanedNumber)) return { isValid: true, errorMessage: "" };
    return { isValid: false, errorMessage: "Invalid account number format. Please enter a valid account number or IBAN." };
  };

  validateAccountNumber = (accountNumber) => {
    if (!accountNumber || !accountNumber.trim()) return { isValid: false, errorMessage: "Account number / IBAN is required" };
    const cleanedInput = accountNumber.trim().toUpperCase().replace(/\s/g, "");
    if (/^[A-Z]{2}\d{2}/.test(cleanedInput)) return this.validateIBAN(accountNumber);
    return this.validateGenericAccountNumber(accountNumber);
  };

  formatIBANInput = (value) => {
    const cleaned = value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
    if (/^[A-Z]{2}\d{2}[A-Z0-9]+$/.test(cleaned) && cleaned.length <= 34) {
      return cleaned.match(/.{1,4}/g)?.join(" ") || cleaned;
    }
    return value;
  };

  /* ─────────────────────────────────────────────
     Other Validation Helpers
  ───────────────────────────────────────────── */

  validateAccountHolderName = (name) => {
    if (!name.trim()) return { isValid: false, errorMessage: "Account holder name is required" };
    if (name.trim().length < 3) return { isValid: false, errorMessage: "Name must be at least 3 characters long" };
    if (name.trim().length > 100) return { isValid: false, errorMessage: "Name must not exceed 100 characters" };
    if (!/^[a-zA-Z\s]+$/.test(name)) return { isValid: false, errorMessage: "Name can only contain letters and spaces" };
    return { isValid: true, errorMessage: "" };
  };

  validateIFSCCode = (code) => {
    if (!code.trim()) return { isValid: false, errorMessage: "IFSC code is required" };
    if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(code.trim().toUpperCase())) return { isValid: false, errorMessage: "Invalid IFSC code format (e.g., SBIN0001234)" };
    return { isValid: true, errorMessage: "" };
  };

  validateSWIFTCode = (code) => {
    if (!code.trim()) return { isValid: false, errorMessage: "SWIFT code is required" };
    if (!/^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(code.trim().toUpperCase())) return { isValid: false, errorMessage: "Invalid SWIFT code format (e.g., SBININBB123)" };
    return { isValid: true, errorMessage: "" };
  };

  validateRoutingNumber = (code) => {
    if (!code.trim()) return { isValid: false, errorMessage: "Routing number is required" };
    if (!/^\d{9}$/.test(code.trim())) return { isValid: false, errorMessage: "Routing number must be exactly 9 digits" };
    return { isValid: true, errorMessage: "" };
  };

  validateCodeValue = (codeType, codeValue) => {
    switch (codeType) {
      case "IFSC CODE": return this.validateIFSCCode(codeValue);
      case "SWIFT CODE": return this.validateSWIFTCode(codeValue);
      case "ROUTING NUMBER": return this.validateRoutingNumber(codeValue);
      default: return { isValid: false, errorMessage: "Invalid code type" };
    }
  };

  validateBankName = (name) => {
    if (!name.trim()) return { isValid: false, errorMessage: "Bank name is required" };
    if (name.trim().length < 3) return { isValid: false, errorMessage: "Bank name must be at least 3 characters long" };
    if (name.trim().length > 100) return { isValid: false, errorMessage: "Bank name must not exceed 100 characters" };
    if (!/^[a-zA-Z0-9\s]+$/.test(name)) return { isValid: false, errorMessage: "Bank name can only contain letters, numbers and spaces" };
    return { isValid: true, errorMessage: "" };
  };

  validateBankAddress = (address) => {
    if (!address.trim()) return { isValid: false, errorMessage: "Bank address is required" };
    if (address.trim().length < 5) return { isValid: false, errorMessage: "Bank address must be at least 5 characters long" };
    if (address.trim().length > 200) return { isValid: false, errorMessage: "Bank address must not exceed 200 characters" };
    if (!/^[a-zA-Z0-9\s,.\-\/]+$/.test(address.trim())) return { isValid: false, errorMessage: "Address can only contain letters, numbers, spaces, and - / . ," };
    return { isValid: true, errorMessage: "" };
  };

  /* ─────────────────────────────────────────────
     Bank Doc Validation
  ───────────────────────────────────────────── */

  validateBankDocType = (docType) => {
    if (!docType || !docType.trim()) return { isValid: false, errorMessage: "Please select a document type" };
    return { isValid: true, errorMessage: "" };
  };

  validateBankDocFile = (file) => {
    if (!file) return { isValid: false, errorMessage: "Please upload a bank verification document" };
    if (!ACCEPTED_FILE_TYPES.includes(file.type)) return { isValid: false, errorMessage: "Only PDF, JPG, or PNG files are accepted" };
    if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) return { isValid: false, errorMessage: `File size must not exceed ${MAX_FILE_SIZE_MB} MB` };
    return { isValid: true, errorMessage: "" };
  };

  validateAllFields = () => {
    const {
      accountHolderName, accountNumber, codeType, codeValue,
      bankName, bankAddress, bankDocType, bankDocFile,
    } = this.state;

    const nameResult = this.validateAccountHolderName(accountHolderName);
    const accNoResult = this.validateAccountNumber(accountNumber);
    const codeResult = this.validateCodeValue(codeType, codeValue);
    const bankNmResult = this.validateBankName(bankName);
    const bankAdResult = this.validateBankAddress(bankAddress);
    const docTypeResult = this.validateBankDocType(bankDocType);
    const docFileResult = this.validateBankDocFile(bankDocFile);

    this.setState({
      isAccountHolderNameInvalid: !nameResult.isValid,
      isAccountNumberInvalid: !accNoResult.isValid,
      isCodeValueInvalid: !codeResult.isValid,
      isBankNameInvalid: !bankNmResult.isValid,
      isBankAddressInvalid: !bankAdResult.isValid,
      isBankDocTypeInvalid: !docTypeResult.isValid,
      isBankDocFileInvalid: !docFileResult.isValid,

      accountHolderNameError: nameResult.errorMessage,
      accountNumberError: accNoResult.errorMessage,
      codeValueError: codeResult.errorMessage,
      bankNameError: bankNmResult.errorMessage,
      bankAddressError: bankAdResult.errorMessage,
      bankDocTypeError: docTypeResult.errorMessage,
      bankDocFileError: docFileResult.errorMessage,
    });

    return (
      nameResult.isValid &&
      accNoResult.isValid &&
      codeResult.isValid &&
      bankNmResult.isValid &&
      bankAdResult.isValid &&
      docTypeResult.isValid &&
      docFileResult.isValid
    );
  };

  /* ─────────────────────────────────────────────
     Individual field blur validators
  ───────────────────────────────────────────── */

  checkAccountHolderName = (e) => {
    const result = this.validateAccountHolderName(e.target.value);
    this.setState({ isAccountHolderNameInvalid: !result.isValid, accountHolderNameError: result.errorMessage });
  };

  checkAccountNumber = (e) => {
    const result = this.validateAccountNumber(e.target.value);
    this.setState({ isAccountNumberInvalid: !result.isValid, accountNumberError: result.errorMessage });
  };

  checkCodeValue = (e) => {
    const result = this.validateCodeValue(this.state.codeType, e.target.value);
    this.setState({ isCodeValueInvalid: !result.isValid, codeValueError: result.errorMessage });
  };

  checkBankName = (e) => {
    const result = this.validateBankName(e.target.value);
    this.setState({ isBankNameInvalid: !result.isValid, bankNameError: result.errorMessage });
  };

  checkBankAddress = (e) => {
    const result = this.validateBankAddress(e.target.value);
    this.setState({ isBankAddressInvalid: !result.isValid, bankAddressError: result.errorMessage });
  };

  /* ─────────────────────────────────────────────
     File upload handlers
  ───────────────────────────────────────────── */

  handleFileSelect = (file) => {
    if (!file) return;
    const result = this.validateBankDocFile(file);
    this.setState({
      bankDocFile: result.isValid ? file : null,
      bankDocFileName: result.isValid ? file.name : "",
      isBankDocFileInvalid: !result.isValid,
      bankDocFileError: result.errorMessage,
    });
  };

  handleFileInputChange = (e) => {
    const file = e.target.files && e.target.files[0];
    this.handleFileSelect(file);
    // Reset input so same file can be re-selected after removal
    e.target.value = "";
  };

  handleDrop = (e) => {
    e.preventDefault();
    this.setState({ isDragOver: false });
    const file = e.dataTransfer.files && e.dataTransfer.files[0];
    this.handleFileSelect(file);
  };

  handleDragOver = (e) => {
    e.preventDefault();
    this.setState({ isDragOver: true });
  };

  handleDragLeave = () => {
    this.setState({ isDragOver: false });
  };

  handleRemoveFile = () => {
    this.setState({
      bankDocFile: null,
      bankDocFileName: "",
      isBankDocFileInvalid: false,
      bankDocFileError: "",
    });
  };

  /* ─────────────────────────────────────────────
     Data fetching
  ───────────────────────────────────────────── */

  renderBankDetails = (uuid) => {
    GetUserBankDetails({ uuid })
      .then(
        function (responseBankDetails) {
          this.setState({ showLoader: false });
          const responseData = responseBankDetails && responseBankDetails.data;
          const error = responseData.error;
          if (error && error.error_data === 1) { showToast("error", error.error_msg); return; }
          const r = responseData.bankDetails;
          if (!r) return;
          const codeType =
            r.routing_no && r.routing_no !== "" ? "ROUTING NUMBER" :
              r.swiftCode && r.swiftCode !== "" ? "SWIFT CODE" :
                r.ifscCode && r.ifscCode !== "" ? "IFSC CODE" : "ROUTING NUMBER";
          const codeValue =
            r.routing_no && r.routing_no !== "" ? r.routing_no :
              r.swiftCode && r.swiftCode !== "" ? r.swiftCode :
                r.ifscCode && r.ifscCode !== "" ? r.ifscCode : "";
          this.setState({
            accountHolderName: r.benificiary_name || "",
            accountNumber: r.account_no || "",
            accountType: r.accountType || "Personal Savings",
            codeType,
            codeValue,
            bankName: r.bank_name || "",
            bankAddress: r.bankAddress || "",
            bankDocType: r.bankDocType || "Voided Check",
          });
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          console.error("Failed to render bank details", err);
          showToast("error", err.message || "An unexpected error occurred");
        }.bind(this)
      );
  };

  /* ─────────────────────────────────────────────
     Save handler
  ───────────────────────────────────────────── */

  handleSave = () => {
    const isValid = this.validateAllFields();
    if (!isValid) {
      showToast("error", "Please fix all validation errors before submitting");
      return;
    }

    const {
      userUuid, accountHolderName, bankName, bankAddress, accountType,
      accountNumber, codeType, codeValue, continueUrl,
      bankDocType, bankDocFile, userCountry,
    } = this.state;

    const cleanedAccountNumber = accountNumber.trim().replace(/\s/g, "");

    // Use FormData so the file can be sent alongside other fields
    const formData = new FormData();

    const bankData = {
      uuid: localStorage.getItem(SITENAMEALIAS + "_exchange_uuid"),
      benificiary_name: accountHolderName.trim(),
      bank_name: bankName.trim(),
      account_no: cleanedAccountNumber,
      accountType: accountType,
      ifscCode: codeType === "IFSC CODE" ? codeValue.trim().toUpperCase() : "",
      swiftCode: codeType === "SWIFT CODE" ? codeValue.trim().toUpperCase() : "",
      routing_no: codeType === "ROUTING NUMBER" ? codeValue.trim() : "",
      bankAddress: bankAddress.trim(),
      country: userCountry,
      bankVerificationDocType: bankDocType,
    };
    formData.append("bankData", JSON.stringify(bankData));
    if (bankDocFile) {
      formData.append("doc", bankDocFile);
    }

    this.setState({ showLoader: true });

    UpdateUserBankDetails(formData)
      .then(
        function (response) {
          this.setState({ showLoader: false });
          const res = response && response.data;
          if (res.error && res.error.error_data === 1) {
            showToast("error", res.error.error_msg || "Failed to save bank details");
            return;
          }
          this.setState({ saveSuccess: true });
          showToast("success", "Bank details saved successfully");
          if (userUuid) this.renderBankDetails(userUuid);

          setTimeout(() => {
            if (continueUrl) {
              this.props.history.push(continueUrl);
            } else {
              window.location.reload();
            }
          }, 2000);
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          console.error("Failed to save bank details", err);
          showToast("error", err.message || "An unexpected error occurred");
        }.bind(this)
      );
  };

  /* ─────────────────────────────────────────────
     Status helpers
  ───────────────────────────────────────────── */

  getBankDetailsStatusMessage = () => {
    const { bankDetailsStatus } = this.state;
    if (bankDetailsStatus === "" || bankDetailsStatus === null || bankDetailsStatus === undefined) return "Bank details not submitted.";
    if (bankDetailsStatus === 0 || bankDetailsStatus === "0") return "Bank details submitted for Verification.";
    if (bankDetailsStatus === 2 || bankDetailsStatus === "2") return "Bank details verified.";
    if (bankDetailsStatus === 3 || bankDetailsStatus === "3") return "Bank documents declined, please submit again.";
    return "Bank details not submitted.";
  };

  getStatusBadgeStyle = () => {
    const { bankDetailsStatus } = this.state;
    if (bankDetailsStatus === 0 || bankDetailsStatus === "0") return styles.statusPending;
    if (bankDetailsStatus === 2 || bankDetailsStatus === "2") return styles.statusVerified;
    if (bankDetailsStatus === 3 || bankDetailsStatus === "3") return styles.statusDeclined;
    return styles.statusDefault;
  };

  getStatusLabel = () => {
    const { bankDetailsStatus } = this.state;
    if (bankDetailsStatus === 0 || bankDetailsStatus === "0") return "Pending Verification";
    if (bankDetailsStatus === 2 || bankDetailsStatus === "2") return "Verified";
    if (bankDetailsStatus === 3 || bankDetailsStatus === "3") return "Declined";
    return "Not Submitted";
  };

  /* ─────────────────────────────────────────────
     Lifecycle
  ───────────────────────────────────────────── */

  componentDidMount() {
    const searchParams = new URLSearchParams(this.props.location.search);
    const redirectedUrl = searchParams.get("continue") || null;
    const decodedUrl = redirectedUrl ? decodeURIComponent(redirectedUrl) : null;
    this.setState({ continueUrl: decodedUrl, showLoader: true });

    const rawList = localStorage.getItem("bill_bitcoins_access_list");
    const accessList = rawList && rawList !== "undefined" ? JSON.parse(rawList) : [];
    const hasWriteAccess =
      !Array.isArray(accessList) ||
      accessList.length === 0 ||
      accessList.some((item) => item.menu === "Add Bank" && item.access === "WRITE");
    this.setState({ hasWriteAccess });

    GetUserDetails()
      .then((response) => {
        const data = response && response.data;
        if (data) {
          const uuid = data.uuid || null;
          this.setState({
            userUuid: uuid,
            bankDetailsStatus: data.bankDetailsStatus ?? "",
            userCountry: data.country || "",
          });
          this.renderBankDetails(uuid);
        }
      })
      .catch((err) => {
        console.error("Failed to get user details", err);
        showToast("error", err.message || "Failed to load user details");
      })
      .finally(() => {
        this.setState({ showLoader: false });
      });
  }

  /* ─────────────────────────────────────────────
     Render
  ───────────────────────────────────────────── */

  render() {
    const {
      accountHolderName, accountNumber, accountType, codeType, codeValue,
      bankName, bankAddress,
      isAccountHolderNameInvalid, isAccountNumberInvalid, isCodeValueInvalid,
      isBankNameInvalid, isBankAddressInvalid,
      accountHolderNameError, accountNumberError, codeValueError,
      bankNameError, bankAddressError,
      bankDetailsStatus, saveSuccess, hasWriteAccess,
      bankDocType, bankDocFileName,
      isBankDocTypeInvalid, isBankDocFileInvalid,
      bankDocTypeError, bankDocFileError,
      isDragOver,
    } = this.state;

    return (
      <Fragment>
        <div className="container-scroller">
          <Sidebar />
          <Header />
          <div className="main-panel">
            <div style={styles.pageWrapper}>
              <PageHeader
                icon="mdi-bank-plus"
                title="Add Bank Account"
                subtitle={this.getBankDetailsStatusMessage()}
              >
                <span style={{ ...styles.statusBadge, ...this.getStatusBadgeStyle() }}>
                  {this.getStatusLabel()}
                </span>
              </PageHeader>

              {/* ── Save Success Alert ── */}
              {saveSuccess && (
                <div style={{ ...styles.successBox, marginBottom: "20px", display: "flex", alignItems: "center", gap: "10px" }}>
                  <i className="fa fa-check-circle"></i>
                  Bank details saved successfully!
                </div>
              )}

              {/* ── Account Information Card ── */}
              <div style={styles.card}>
                <div style={styles.cardHeaderRow}>
                  <div style={{ ...styles.cardHeaderIcon, ...styles.iconBlue }}>
                    <i className="fa fa-user"></i>
                  </div>
                  <div>
                    <h5 style={styles.cardTitle}>Account Information</h5>
                    <div style={styles.cardSubtitle}>Your bank account holder details</div>
                  </div>
                </div>

                <form onSubmit={(e) => e.preventDefault()}>
                  <div style={styles.gridTwo}>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Account Holder's Name *</label>
                      <input
                        type="text"
                        style={{ ...styles.input, ...(isAccountHolderNameInvalid ? styles.inputError : {}) }}
                        placeholder="Enter account holder's name"
                        value={accountHolderName}
                        readOnly={!hasWriteAccess}
                        onChange={(e) => this.setState({ accountHolderName: e.target.value })}
                        onBlur={this.checkAccountHolderName}
                      />
                      {isAccountHolderNameInvalid && <div style={styles.errorText}>{accountHolderNameError}</div>}
                    </div>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>IBAN / Account Number *</label>
                      <input
                        type="text"
                        style={{ ...styles.input, ...(isAccountNumberInvalid ? styles.inputError : {}) }}
                        placeholder="Enter IBAN or account number"
                        value={accountNumber}
                        readOnly={!hasWriteAccess}
                        onChange={(e) => this.setState({ accountNumber: this.formatIBANInput(e.target.value) })}
                        onBlur={this.checkAccountNumber}
                      />
                      {isAccountNumberInvalid && <div style={styles.errorText}>{accountNumberError}</div>}
                      <div style={{ fontSize: "11px", opacity: 0.5, marginTop: "4px" }}>
                        Supports IBAN, UK sort code (12-34-56 12345678), US, Indian, and international account numbers
                      </div>
                    </div>
                  </div>

                  <div style={styles.gridThree}>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Account Type *</label>
                      <select
                        style={styles.select}
                        value={accountType}
                        disabled={!hasWriteAccess}
                        onChange={(e) => this.setState({ accountType: e.target.value })}
                      >
                        <option value="Personal Savings">Personal Savings</option>
                        <option value="Personal Current">Personal Current</option>
                        <option value="Business Savings">Business Savings</option>
                        <option value="Business Current">Business Current</option>
                      </select>
                    </div>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Code Type *</label>
                      <select
                        style={styles.select}
                        value={codeType}
                        disabled={!hasWriteAccess}
                        onChange={(e) =>
                          this.setState({ codeType: e.target.value, codeValue: "", isCodeValueInvalid: false, codeValueError: "" })
                        }
                      >
                        <option value="ROUTING NUMBER">ROUTING NUMBER</option>

                        <option value="SWIFT CODE">SWIFT CODE</option>
                        <option value="IFSC CODE">IFSC CODE</option>

                      </select>
                    </div>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Enter Code *</label>
                      <input
                        type="text"
                        style={{ ...styles.input, ...(isCodeValueInvalid ? styles.inputError : {}) }}
                        placeholder={`Enter ${codeType.toLowerCase()}`}
                        value={codeValue}
                        readOnly={!hasWriteAccess}
                        onChange={(e) => this.setState({ codeValue: e.target.value })}
                        onBlur={this.checkCodeValue}
                      />
                      {isCodeValueInvalid && <div style={styles.errorText}>{codeValueError}</div>}
                    </div>
                  </div>
                </form>
              </div>

              {/* ── Bank Information Card ── */}
              <div style={styles.card}>
                <div style={styles.cardHeaderRow}>
                  <div style={{ ...styles.cardHeaderIcon, ...styles.iconPurple }}>
                    <i className="fa fa-landmark"></i>
                  </div>
                  <div>
                    <h5 style={styles.cardTitle}>Bank Information</h5>
                    <div style={styles.cardSubtitle}>Your bank name and branch address</div>
                  </div>
                </div>

                <form onSubmit={(e) => e.preventDefault()}>
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Bank Name *</label>
                    <input
                      type="text"
                      style={{ ...styles.input, ...(isBankNameInvalid ? styles.inputError : {}) }}
                      placeholder="Enter bank name"
                      value={bankName}
                      readOnly={!hasWriteAccess}
                      onChange={(e) => this.setState({ bankName: e.target.value })}
                      onBlur={this.checkBankName}
                    />
                    {isBankNameInvalid && <div style={styles.errorText}>{bankNameError}</div>}
                  </div>
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Bank Address *</label>
                    <input
                      type="text"
                      style={{ ...styles.input, ...(isBankAddressInvalid ? styles.inputError : {}) }}
                      placeholder="Enter bank address"
                      value={bankAddress}
                      readOnly={!hasWriteAccess}
                      onChange={(e) => this.setState({ bankAddress: e.target.value })}
                      onBlur={this.checkBankAddress}
                    />
                    {isBankAddressInvalid && <div style={styles.errorText}>{bankAddressError}</div>}
                  </div>
                </form>
              </div>

              {/* ── Bank Verification Document Card (NEW) ── */}
              <div style={styles.card}>
                <div style={styles.cardHeaderRow}>
                  <div style={{ ...styles.cardHeaderIcon, ...styles.iconOrange }}>
                    <i className="fa fa-file-alt"></i>
                  </div>
                  <div>
                    <h5 style={styles.cardTitle}>Bank Verification Document</h5>
                    <div style={styles.cardSubtitle}>Upload a document to verify your bank account</div>
                  </div>
                </div>

                {/* Accepted document types */}
                <div style={{ marginBottom: "18px" }}>
                  <label style={styles.label}>Please upload one of the following:</label>
                  <ul style={styles.docTypeList}>
                    {BANK_DOC_TYPES.map((type) => (
                      <li key={type} style={styles.docTypeItem}>
                        <span style={styles.docTypeDot}></span>
                        {type}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* What the document must show */}
                <div style={styles.requiresBox}>
                  <strong>
                    <i className="fa fa-info-circle" style={{ marginRight: "6px" }}></i>
                    Uploaded document should show:
                  </strong>
                  <ul style={{ margin: "8px 0 0 0", padding: "0 0 0 20px", lineHeight: "1.8" }}>
                    <li>Account Holder Name</li>
                    <li>Bank Name</li>
                    <li>Account Number (partially masked if needed)</li>
                    <li>Routing / IFSC / SWIFT details (as applicable)</li>
                  </ul>
                </div>

                <form onSubmit={(e) => e.preventDefault()}>
                  <div style={styles.gridTwo}>
                    {/* Document type dropdown */}
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Bank Account Verification Document Type *</label>
                      <select
                        style={{
                          ...styles.select,
                          ...(isBankDocTypeInvalid ? { borderColor: "#ef4444" } : {}),
                        }}
                        value={bankDocType}
                        disabled={!hasWriteAccess}
                        onChange={(e) =>
                          this.setState({
                            bankDocType: e.target.value,
                            isBankDocTypeInvalid: false,
                            bankDocTypeError: "",
                          })
                        }
                      >
                        {BANK_DOC_TYPES.map((type) => (
                          <option key={type} value={type}>{type}</option>
                        ))}
                      </select>
                      {isBankDocTypeInvalid && <div style={styles.errorText}>{bankDocTypeError}</div>}
                    </div>

                    {/* File upload */}
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Upload Bank Verification Document *</label>

                      {/* Hidden file input */}
                      <input
                        ref={this.fileInputRef}
                        type="file"
                        accept=".pdf,.jpg,.jpeg,.png"
                        style={{ display: "none" }}
                        disabled={!hasWriteAccess}
                        onChange={this.handleFileInputChange}
                      />

                      {/* Drag-and-drop / click area */}
                      {!bankDocFileName ? (
                        <div
                          style={{
                            ...styles.uploadArea,
                            ...(isDragOver ? styles.uploadAreaActive : {}),
                            ...(isBankDocFileInvalid ? styles.uploadAreaError : {}),
                            ...(hasWriteAccess ? { cursor: "pointer" } : { cursor: "not-allowed", opacity: 0.6 }),
                          }}
                          onClick={() => hasWriteAccess && this.fileInputRef.current && this.fileInputRef.current.click()}
                          onDrop={hasWriteAccess ? this.handleDrop : undefined}
                          onDragOver={hasWriteAccess ? this.handleDragOver : undefined}
                          onDragLeave={hasWriteAccess ? this.handleDragLeave : undefined}
                        >
                          <i className="fa fa-cloud-upload-alt" style={styles.uploadIcon}></i>
                          <div style={styles.uploadText}>
                            {isDragOver ? "Drop your file here" : "Click or drag & drop to upload"}
                          </div>
                          <div style={styles.uploadHint}>Accepted formats: PDF, JPG, PNG (Max 5 MB)</div>
                        </div>
                      ) : (
                        <div style={styles.uploadedFile}>
                          <i className="fa fa-file-check" style={{ color: "#10b981", fontSize: "18px" }}></i>
                          <span style={styles.uploadedFileName} title={bankDocFileName}>{bankDocFileName}</span>
                          {hasWriteAccess && (
                            <button
                              type="button"
                              style={styles.uploadRemoveBtn}
                              onClick={this.handleRemoveFile}
                              title="Remove file"
                            >
                              <i className="fa fa-times"></i>
                            </button>
                          )}
                        </div>
                      )}

                      {isBankDocFileInvalid && <div style={styles.errorText}>{bankDocFileError}</div>}
                    </div>
                  </div>
                </form>
              </div>

              {/* ── Info Note & Save ── */}
              <div
                style={{ ...styles.infoBox, marginBottom: "24px", display: "flex", alignItems: "flex-start", gap: "10px" }}
              >
                <i className="fa fa-shield-alt" style={{ marginTop: "2px", opacity: 0.7 }}></i>
                <div>
                  <strong>Note:</strong> Ensure all bank details are accurate before submission. Any discrepancies may
                  result in transaction delays or rejection. Your bank information is encrypted and securely stored.
                </div>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                {hasWriteAccess && (
                  <button type="button" style={styles.btnPrimary} onClick={this.handleSave}>
                    Save Changes
                  </button>
                )}
                {!hasWriteAccess && (
                  <div style={{ ...styles.infoBox, marginBottom: "24px" }}>
                    <i className="fa fa-lock" style={{ marginRight: "8px" }}></i>
                    You do not have write access to bank details.
                  </div>
                )}
                <button
                  type="button"
                  style={styles.btnBack}
                  onClick={() => this.props.history.goBack()}
                >
                  <i className="fa fa-arrow-left" style={{ fontSize: "12px" }}></i>
                  Back
                </button>
              </div>
            </div>
            <Footer />
          </div>
          <Loader show={this.state.showLoader} />
        </div>
      </Fragment>
    );
  }
}

export default withRouter(BankDetails);